import img1 from "../../images/icons/icon-1.png";
import img2 from "../../images/icons/icon-2.png";
import img3 from "../../images/icons/icon-3.png";
import img4 from "../../images/icons/icon-4.png";
import img5 from "../../images/icons/icon-5.png";
import img6 from "../../images/icons/icon-6.png";

const data = {
  serviceData: [
    {
      image: img1,
      title: "Html 5",
      desc: "It widely used in website development. Using HTML, we create text with links and hyperlinks that can turn letters into images, tables, and other representations.",
      link: "https://developer.mozilla.org/en-US/docs/Glossary/HTML5",
    },
    {
      image: img2,
      title: "css 3",
      desc: "It determines the size, font, colors and other static elements of the frontend. It offers different styles to format the HTML components on the browser.",
      link: "https://developer.mozilla.org/en-US/docs/Web/CSS",
    },
    {
      image: img3,
      title: "JavaScript",
      desc: "It is the most popular programming language for front-end logic. the web which is used by several websites for scripting the webpages.",
      link: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
    },

    {
      image: img4,
      title: "sass",
      desc: "Sass is a preprocessor scripting language that is interpreted or compiled into Cascading Style Sheets. SassScript is the scripting language itself.",
      link: "https://sass-lang.com/",
    },

    {
      image: img5,
      title: "wordpress",
      desc: "It is the most popular CMS for website development. It is a content management system (CMS) for creating and managing web sites.",
      link: "https://getbootstrap.com/",
    },
    {
      image: img6,
      title: "react.Js",
      desc: "It is a most popular library of java-script language for creating client side user interfaces and is used as a base for developing single page applications.",
      link: "https://reactjs.org/",
    },
  ],
};

export default data;
